import ProductContainer from '../Container';
import CardBodyBottomInfo from '../meta/card-body/card-body-bottom-info';
import CardBodyMetrics from '../meta/card-body/card-body-metrics';
import CardBodyProductName from '../meta/card-body/card-body-product-name';
import CardBodyTopTag from '../meta/card-body/card-body-top-tag';
import CardHeadImage from '../meta/card-head/card-head-image';
import CardHeadSoldOut from '../meta/card-head/card-head-soldout';
import CardHeadLabel from '../meta/card-head/card-head-label';
import { ProductCardProps } from '../types';
import Trans from 'next-translate/Trans';
import ProductAddCart from '../meta/add-cart';
import ProductPriceV2 from './meta/product-price-v2';
import useTranslation from 'next-translate/useTranslation';
import ProductBrandImg from './meta/product-brand-img';
import EnchancedFavorite from '../meta/enchanced-favorite';

const SkuHorizontalProductCard: React.FC<Partial<ProductCardProps>> = props => {
  const { data } = props;

  const { t } = useTranslation('common');

  return (
    // <ProductContainer {...props} className="p-0 !rounded-400 bg-transparent">
    <ProductContainer
      orientation="h"
      {...props}
      className=""
      interactiveSlot={
        <div className="absolute left-0 top-0 w-[180px] h-[180px] pointer-events-none">
          <EnchancedFavorite {...props} />
        </div>
      }>
      <div className="h-full w-full flex justify-start items-start relative box-border">
        <div className="pt-0 relative w-[180px] h-[180px] flex-none" data-role="image-container">
          <CardHeadImage
            imageSize={180}
            className="w-[180px] h-[180px] rounded-400"
            imageProps={{
              placeholderClassName: 'rounded-400 bg-product-bg-img-tint',
              boxClassName: 'rounded-400 bg-product-bg-img-tint border-solid border-input-100-hairline-default border'
            }}
            {...props}
          />

          <CardHeadLabel {...props} showFavorite={false} showBigOffLabel={true} bigOffLabelCls="top-0 -left-0.5" />

          <CardHeadSoldOut
            {...props}
            cardType="horizontal"
            className="top-0 left-0 w-full h-full rounded-300 text-center"
          />

          <div className="absolute right-2 bottom-2">
            <ProductBrandImg {...props} />
          </div>
        </div>
        <div data-role="mid-box" className="flex-1 flex flex-col self-stretch justify-center mx-2 py-2 overflow-hidden">
          <ProductPriceV2 data={data} />
          <div>
            <CardBodyTopTag {...props} />
            <CardBodyProductName {...props} cardType="horizontal" productNameClass="enki-body-sm-medium" />
            <ProductAddCart
              addCartBtnClassName="static w-full my-2"
              // className="bg-btn-primary-bg rounded-full enki-elevation-4 relative h-[40px] px-0 enki-body-sm-medium text-atc-mini-fg-added"
              className="bg-btn-primary-bg rounded-full relative h-[40px] px-0 enki-body-sm-medium text-atc-mini-fg-added"
              remindedFontClassName="enki-body-sm-medium"
              remindFontClassName="enki-body-sm-medium"
              changeOtherDayFontClassName="enki-body-sm-medium"
              text={t('add_to_cart')}
              data={data}
              cardType="horizontal"
              {...props}
              isInProductCard
              isHoriziontal
              hideIcon
            />
            <CardBodyMetrics {...props} />
            {/* <CardBodyBottomInfo {...props} className="mx-0 mt-1" cardType="horizontal" /> */}
            <CardBodyBottomInfo
              {...props}
              className="mt-0 mb-0"
              productTagClassNames="gap-x-0.5"
              tagClassName="gap-y-2"
              tagItemClassName="mb-0"
              mainBottomContentCls="gap-y-2"
              etaClassName="enki-body-xs-medium"
              shipsFromClassName="enki-body-xs-medium"
            />
          </div>
          <div>
            {props.showExtraTag && !!+data?.discount_percentage && (
              <span className="text-[10px] inline-block px-1 h-5 leading-5 mt-0 mb-1 rounded bg-orange-200 font-semibold text-center text-orange-600">
                <Trans
                  i18nKey="common:order_share_grocery_extra_tag"
                  components={{
                    span: <span />
                  }}
                  values={{
                    discount: data?.discount_percentage
                  }}
                />
              </span>
            )}

            {/* max-width: 150px在宽度375的屏幕上还是会遮挡 */}
            {/* <CardBodyPreSale {...props} />
            <CardBodyMkplEta {...props} className={twMerge('my-0.5 max-w-[138px]', isPc && 'max-w-full')} />
            <CardBodyMkplShip {...props} className={twMerge('my-0.5 max-w-[138px]', isPc && 'max-w-full')} />
            <CardBodyLinkedTag {...props} /> */}
          </div>
        </div>
      </div>
    </ProductContainer>
  );
};

export default SkuHorizontalProductCard;
